module.exports = __webpack_public_path__ + "static/media/logo2.ee17b903.svg";